var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBase11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 650,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 650,
    height: 650
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 650,
    height: 650
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325 0C145.528 0 0 145.528 0 325 0 434.254 54.0944 530.689 136.753 589.604 138.631 473.363 96.3625 343.056 25.35 343.056 16.9722 343.056 10.1833 344.247 4.53194 346.36 10.0028 332.692 21.8653 325 44.0556 325 121.153 325 164.414 478.581 154.05 601.033 203.775 631.89 262.203 650 325 650 387.815 650 446.261 631.872 495.986 601.015 485.568 478.111 528.811 325 605.963 325 628.225 325 640.124 332.692 645.54 346.36 639.871 344.247 633.064 343.056 624.65 343.056 553.547 343.056 511.297 473.038 513.247 589.604 595.924 530.689 650 434.254 650 325 650 145.528 504.49 0 325 0Z",
    fill: "#FFCC4D",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 0C145.528 0 0 145.563 0 325.079 0 346.607 2.22083 367.629 6.21111 388 10.4361 372.415 17.0444 357.461 25.3139 343.139 16.9542 343.139 10.1833 344.331 4.55 346.444 9.31667 334.543 19.3917 327.518 36.4722 325.82 90.4944 250.347 199.279 198.66 325 198.66 450.739 198.66 559.506 250.329 613.528 325.802 630.681 327.5 640.792 334.507 645.522 346.444 639.889 344.331 633.082 343.139 624.704 343.139 632.974 357.461 639.564 372.415 643.807 388 647.797 367.629 650 346.607 650 325.079 650 145.563 504.49 0 325 0Z",
    fill: "#BDDDF4",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5893 343.286C17.2193 343.286 10.4368 344.477 4.79068 346.588 6.08947 343.358 7.80315 340.526 9.85956 338-23.7285 379.334 51.6552 515.407 15.0186 650L131.549 650C153.015 524.428 109.271 343.286 25.5893 343.286ZM645.2 346.588C639.536 344.477 632.736 343.286 624.33 343.286 540.612 343.286 496.886 523.742 518.388 650L634.918 650C600.536 522.894 664.79 395.807 645.2 346.588Z",
    fill: "#FCAB40",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase11);
export default __webpack_public_path__ + "static/media/base11.e7d2946622cedd3944204354df4e3f9a.svg";
export { ForwardRef as ReactComponent };